import { ref } from 'vue';
import { createGlobalState } from '@vueuse/core';
import type { IExpertSearchListItem, } from '@/types';
import { IExpertSearch } from '@/services/expert-search';
import type { Route } from 'vue-router';
import type { SearchProjectInfo } from '@/services/project-service';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';

export const useExpertSearch = createGlobalState(() => {
    const searchProjectInfo = ref<SearchProjectInfo>();

    const isProjectSearch = ref<boolean>(false);

    const projectQueryList = ref<IExpertSearchListItem[]>([]);

    function _updateProjectInfo(info: SearchProjectInfo) {
        searchProjectInfo.value = info;
    }

    function _updateProjectQueryList(items: IExpertSearchListItem[]) {
        projectQueryList.value = items;
    }

    function _updateProjectSearchStatus(bool: boolean) {
        isProjectSearch.value = bool;
    }

    const expertSearch = injectService<IExpertSearch>(IExpertSearch);

    /**
     * 检查是否开启专家搜索，如果开启，则更新相关数据。
     * @param route
     */
    async function checkExpertSearch(route: Route) {
        if (expertSearch.checkEnabled(route)) {
            _updateProjectSearchStatus(true);
            await expertSearch.fetchData(route);
            _updateProjectQueryList(expertSearch.items);
            if (expertSearch.searchProjectInfo) {
                _updateProjectInfo(expertSearch.searchProjectInfo);
            }
        }
    }

    function transQuery(data: { query: string }) {
        if (isProjectSearch.value) {
            const query = expertSearch.convertQuery(data.query);
            return {
                query,
            };
        }
        return data;
    }

    return {
        searchProjectInfo,
        isProjectSearch,
        projectQueryList,
        checkExpertSearch,
        transQuery,
    };
});
